import Cookies from 'js-cookie'

const TOKEN_KEY = 'token'
const USER_INFO_KEY = 'userInfo'

// Token管理
export function getToken() {
  return Cookies.get(TOKEN_KEY)
}

export function setToken(token) {
  return Cookies.set(TOKEN_KEY, token, { expires: 1 }) // 1天过期
}

export function removeToken() {
  return Cookies.remove(TOKEN_KEY)
}

// 用户信息管理
export function getUserInfo() {
  const userInfo = Cookies.get(USER_INFO_KEY)
  return userInfo ? JSON.parse(userInfo) : null
}

export function setUserInfo(userInfo) {
  return Cookies.set(USER_INFO_KEY, JSON.stringify(userInfo), { expires: 1 })
}

export function removeUserInfo() {
  return Cookies.remove(USER_INFO_KEY)
}

// 检查是否登录
export function isLoggedIn() {
  return !!getToken()
}

// 检查用户角色
export function hasRole(role) {
  const userInfo = getUserInfo()
  if (!userInfo) return false
  if (userInfo.role === 'admin') return true // 管理员拥有所有权限
  return userInfo.role === role
}

// 角色类型
export const ROLES = {
  AFTER_SALES: 'after_sales',
  ADMIN: 'admin',
  PURCHASER: 'purchaser',        // 采购员
  WAREHOUSE_KEEPER: 'warehouse_keeper'  // 仓管员
}

// 菜单权限管理
const MENU_PATHS_KEY = 'userMenuPaths'

// 设置用户菜单路径列表
export function setUserMenuPaths(menuList) {
  const paths = extractMenuPaths(menuList)
  return Cookies.set(MENU_PATHS_KEY, JSON.stringify(paths), { expires: 1 })
}

// 获取用户菜单路径列表
export function getUserMenuPaths() {
  const paths = Cookies.get(MENU_PATHS_KEY)
  return paths ? JSON.parse(paths) : null
}

// 清除菜单路径
export function removeUserMenuPaths() {
  return Cookies.remove(MENU_PATHS_KEY)
}

// 从菜单树中提取所有路径
function extractMenuPaths(menuList) {
  const paths = []
  
  function traverse(menus) {
    if (!menus || !Array.isArray(menus)) return
    
    menus.forEach(menu => {
      if (menu.path) {
        // 标准化路径：移除开头的 /，统一格式
        const normalizedPath = menu.path.startsWith('/') ? menu.path : `/${menu.path}`
        paths.push(normalizedPath)
      }
      
      if (menu.children && menu.children.length > 0) {
        traverse(menu.children)
      }
    })
  }
  
  traverse(menuList)
  return paths
}

// 检查用户是否有访问某个路径的权限
export function hasMenuPermission(path) {
  const userInfo = getUserInfo()
  if (!userInfo) return false
  
  // 管理员拥有所有权限
  if (userInfo.role === 'admin') return true
  
  // 获取用户菜单路径列表
  const menuPaths = getUserMenuPaths()
  if (!Array.isArray(menuPaths) || menuPaths.length === 0) return false
  
  // 标准化路径：确保以 / 开头
  const normalizedPath = path.startsWith('/') ? path : `/${path}`
  
  // 检查路径是否在菜单权限列表中（精确匹配）
  if (menuPaths.includes(normalizedPath)) {
    return true
  }
  
  // 也检查去掉前导斜杠的版本（兼容性）
  const pathWithoutSlash = normalizedPath.substring(1)
  if (menuPaths.includes(pathWithoutSlash)) {
    return true
  }
  
  return false
}
